/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  FC,
  MouseEvent,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import * as ReactDOM from "react-dom";
import classes from "./Modal.module.scss";

export const MODAL_ROOT_ID = "modal-root";

interface Props {
  show: boolean;
  onClose: () => void;
  title?: string;
  className?: string;
  contentClassName?: string;
  withCloseIcon?: boolean;
  onCloseOuterClick?: boolean;
}

export const Modal: FC<Props> = ({
  show,
  onClose,
  children,
  title,
  className,
  contentClassName,
  withCloseIcon = true,
  onCloseOuterClick = true,
}) => {
  const [isMounted, setIsMounted] = useState(false);

  const modalWrapperRef = useRef<HTMLDivElement | null>(null);

  const backDropHandler = useCallback(
    (e: Event) => {
      if (
        !modalWrapperRef?.current?.contains(e.target as Node) &&
        onCloseOuterClick
      ) {
        onClose();
      }
    },
    [onClose, onCloseOuterClick]
  );

  useEffect(() => {
    setIsMounted(true);

    window.addEventListener("click", backDropHandler);
    window.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && onCloseOuterClick) {
        onClose();
      }
    });

    return () => {
      window.removeEventListener("click", backDropHandler);
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      window.removeEventListener("keydown", () => {});
    };
  }, [backDropHandler, onClose, onCloseOuterClick]);

  const handleCloseClick = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    onClose();
  };

  const modalContent = show ? (
    <div
      className={`${classes.modal} ${className}`}
      data-testid={MODAL_ROOT_ID}
    >
      <div className={classes.modal__wrapper} ref={modalWrapperRef}>
        <div className={`${classes.modal__layout} ${contentClassName}`}>
          {withCloseIcon && (
            <div className={classes.modal__header}>
              <div className={classes.modal__close} onClick={handleCloseClick}>
                x
              </div>
            </div>
          )}

          {title && <h3>{title}</h3>}
          <div className={classes.modal__body}>{children}</div>
        </div>
      </div>
    </div>
  ) : null;

  if (isMounted) {
    return ReactDOM.createPortal(
      modalContent,
      document.getElementById("modal-root")!
    );
  }

  return null;
};

Modal.defaultProps = {
  title: "",
  className: "",
  contentClassName: "",
  withCloseIcon: true,
  onCloseOuterClick: true,
};
